import actionCreatorFactory from 'typescript-fsa';
import { SortingGeneric, TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { ServiceHistoryDtoKeys } from './types';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('service-history-table-settings');

export const setColumnOrderAction = actionCreator<ServiceHistoryDtoKeys[]>(constants.SET_COLUMN_ORDER);
export const setColumnSizeAction = actionCreator<TableColumnWidthInfoGeneric<ServiceHistoryDtoKeys>[]>(
	constants.SET_COLUMN_SIZES
);
export const setColumnSortingAction = actionCreator<SortingGeneric<ServiceHistoryDtoKeys>[]>(
	constants.SET_COLUMN_SORTING
);
